import { probeRender } from '../perf/renderProbe';
import { useCallStore } from '../store/callStore';

export function Toasts() {
  probeRender('Toasts');
  const toasts = useCallStore((s) => s.toasts);
  if (toasts.length === 0) return null;
  return (
    <div className="bz-toasts" role="status">
      {toasts.map((t) => (
        <div key={t.id} className={`bz-toast bz-toast-${t.tone}`}>
          {t.text}
        </div>
      ))}
    </div>
  );
}
